import * as React from "react";
import { Redirect, Route, Switch, useHistory } from "react-router";

import { useAuth, useGlobalData } from "../../contexts";
import { useRouter } from "../../hooks";
import { DrupalNewKennelRequestPage } from "../../pages/request/drupalNewKennelRequest/DrupalNewKennelRequestPage";
import { EDrupalRoutes } from "../EDrupalRoutes";
import { DrupalChangePasswordPage } from "./account";
import { DrupalForgottenPasswordPage } from "./account";
import { DrupalLoginPage } from "./account";
import { DrupalProfileItemPage } from "./account/profile/DrupalProfileItemPage";
import { DrupalEmailErrorPage } from "./account/register/DrupalEmailErrorPage";
import { DrupalRegisterPage } from "./account";
import { DrupalAffixList } from "./affix/DrupalAffixList";
import { DrupalBabyDogDetail } from "./babyDog/detail/DrupalBabyDogDetail";
import { DrupalBabyDogListPage } from "./babyDog/DrupalBabyDogListPage";
import { DrupalBreedDetailPage } from "./breed/DrupalBreedDetailPage";
import { DrupalBreedPage } from "./breed/DrupalBreedPage";
import { DrupalClubDetailPage } from "./club/DrupalClubDetailPage";
import { DrupalClubListPage } from "./club/DrupalClubListPage";
import { DrupalCompetitionItemPage } from "./competition/item/DrupalCompetitionItemPage";
import { DrupalCompetitionListPage } from "./competition/list/DrupalCompetitionListPage";
import { DrupalDogDetailPage, DrupalDogListPage } from "./dog";
import { DrupalGenealogyPage } from "./genalogy/DrupalGenealogyPage";
import { DrupalJudgeListPage } from "./judge/DrupalJudgeListPage";
import { DrupalBroodRequestPage } from "./requests/drupalBroodRequest/DrupalBroodRequestPage";
import { DrupalCompetitionRequestPage } from "./requests/drupalCompetitionRequest/DrupalCompetitionRequestPage";
import { DrupalDysplasiaRequestPage } from "./requests/drupalDysplasiaRequest/DrupalDysplasiaRequestPage";
import { DrupalHealthTestRequestPage } from "./requests/drupalHealthTestRequest/DrupalHealthTestRequestPage";
import { DrupalImportRequestPage } from "./requests/drupalImportRequest/DrupalImportRequestPage";
import { DrupalKennelExportRequestPage } from "./requests/drupalKennelExportRequest/DrupalKennelExportRequestPage";
import { DrupalKennelImportRequestPage } from "./requests/drupalKennelImportRequestPage/DrupalKennelImportRequestPage";
import { DrupalKennelNameChangeRequestPage } from "./requests/drupalKennelNameChangeRequest/DrupalKennelNameChangeRequestPage";
import { DrupalKennelOwnershipChangeRequestPage } from "./requests/drupalKennelOwnershipChangeRequest/DrupalKennelOwnershipChangeRequestPage";
import { DrupalMembershipRequest } from "./requests/drupalMembershipRequest/DrupalMembershipRequest";
import { DrupalMiscellaneousRequestPage } from "./requests/drupalMiscellaneousRequest/DrupalMiscellaneousRequestPage";
import { DrupalNewRequestPage } from "./requests/drupalNewRequest/DrupalNewRequestPage";
import { DrupalPedigreeDuplicataRequestPage } from "./requests/drupalPedigreeDuplicataRequest/DrupalPedigreeDuplicataRequestPage";
import { DrupalRequestListPage } from "./requests/drupalRequestList/DrupalRequestListPage";
import { DrupalRishRequestPage } from "./requests/drupalRishRequest/DrupalRishRequestPage";
import { DrupalRshRequestPage } from "./requests/drupalRshRequest/DrupalRshRequestPage";
import { DrupalTempRshRequestPage } from "./requests/drupaltempRSHRequest/DrupalTempRshRequestPage";
import { DrupalTitleRequestPage } from "./requests/drupalTitleRequest/DrupalTitleRequestPage";
import { DrupalWorkAttestRequestPage } from "./requests/drupalWorkattestRequest/DrupalWorkAttestRequestPage";
import { DrupalWorkbookRequestPage } from "./requests/drupalWorkbookRequest/DrupalWorkbookRequestPage";
import { DrupalNewCompetitionRequest } from "./requests/drupalCompetitionRequest/DrupalNewCompetitionRequest";

export interface IDrupalRouterProps {}

export const DrupalRouter = () => {
  const { user } = useAuth();
  const { location } = useRouter();
  const isLogged = React.useMemo(() => !!user, [user]);
  const { systemInfo } = useGlobalData();

  // Used to disable pages in prod while keeping them in test
  const drupalHideCompetitionRequest = React.useMemo(
    () => systemInfo?.drupalHideCompetitionRequest,
    [systemInfo?.drupalHideCompetitionRequest]
  );

  if (isLogged) {
    return (
      <Switch>
        <Route path={`${EDrupalRoutes.logout}`} component={DrupalLoginPage} exact={true} />
        <Route path={`${EDrupalRoutes.dog}`} component={DrupalDogListPage} exact={true} />
        <Route path={`${EDrupalRoutes.dog}/:dId/:tab`} component={DrupalDogDetailPage} exact={true} />
        <Route path={`${EDrupalRoutes.requestList}`} component={DrupalRequestListPage} exact={true} />
        <Route path={`${EDrupalRoutes.broodRequest}/:id`} component={DrupalBroodRequestPage} />
        <Route path={`${EDrupalRoutes.pedigreeDuplicataRequest}/:id`} component={DrupalPedigreeDuplicataRequestPage} />
        <Route path={`${EDrupalRoutes.membershipRequest}/:id`} component={DrupalMembershipRequest} />
        <Route path={`${EDrupalRoutes.newRequest}`} component={DrupalNewRequestPage} />
        <Route path={`${EDrupalRoutes.rishRequest}/:id`} component={DrupalRishRequestPage} />
        <Route path={`${EDrupalRoutes.titleRequest}/:id`} component={DrupalTitleRequestPage} />
        <Route path={`${EDrupalRoutes.workbookRequest}/:id`} component={DrupalWorkbookRequestPage} />
        <Route path={`${EDrupalRoutes.tempRshRequest}/:id`} component={DrupalTempRshRequestPage} />
        <Route path={`${EDrupalRoutes.dogOwnershipChangeRequest}/:id`} component={DrupalRshRequestPage} />
        <Route path={`${EDrupalRoutes.workAttestRequest}/:id`} component={DrupalWorkAttestRequestPage} />
        <Route path={`${EDrupalRoutes.healthTestRequest}/:id`} component={DrupalHealthTestRequestPage} />
        <Route path={`${EDrupalRoutes.competitionRequest}/:id`} component={DrupalCompetitionRequestPage} />
        <Route path={`${EDrupalRoutes.ImportRequst}/:id`} component={DrupalImportRequestPage} />
        {/* <Route path={`${EDrupalRoutes.dashboard}`} component={DrupalDashboardPage} /> */}
        <Route path={`${EDrupalRoutes.miscellaneousRequest}/:id`} component={DrupalMiscellaneousRequestPage} />
        <Route path={`${EDrupalRoutes.dysplasiaRequest}/:id`} component={DrupalDysplasiaRequestPage} />
        <Route path={`${EDrupalRoutes.kennelImportRequest}/:id`} component={DrupalKennelImportRequestPage} />
        <Route path={`${EDrupalRoutes.newKennelRequest}/:id`} component={DrupalNewKennelRequestPage} />
        <Route path={`${EDrupalRoutes.kennelExportRequest}/:id`} component={DrupalKennelExportRequestPage} />
        <Route path={`${EDrupalRoutes.kennelNameChangeRequest}/:id`} component={DrupalKennelNameChangeRequestPage} />
        {!drupalHideCompetitionRequest && (
          <Route path={`${EDrupalRoutes.portalNewCompetitionRequest}`} component={DrupalNewCompetitionRequest} />
        )}
        <Route
          path={`${EDrupalRoutes.competition}`}
          component={() => DrupalCompetitionListPage({ isCoursing: false })}
          exact
        />
        <Route path={`${EDrupalRoutes.crcb}`} component={() => DrupalCompetitionListPage({ isCoursing: true })} exact />
        <Route path={`${EDrupalRoutes.competition}/:id`} component={DrupalCompetitionItemPage} />
        <Route path={`${EDrupalRoutes.breed}`} component={DrupalBreedPage} exact />
        <Route path={`${EDrupalRoutes.breed}/:id`} component={DrupalBreedDetailPage} />
        <Route path={`${EDrupalRoutes.affix}`} component={DrupalAffixList} />
        <Route path={`${EDrupalRoutes.judge}`} component={DrupalJudgeListPage} />
        <Route path={`${EDrupalRoutes.club}`} component={DrupalClubListPage} exact />
        <Route path={`${EDrupalRoutes.club}/:id`} component={DrupalClubDetailPage} />
        <Route path={`${EDrupalRoutes.profile}/:tab`} component={DrupalProfileItemPage} />
        <Route path={`${EDrupalRoutes.babyDog}`} component={DrupalBabyDogListPage} exact />
        <Route path={`${EDrupalRoutes.babyDog}/:id`} component={DrupalBabyDogDetail} />
        <Route path={`${EDrupalRoutes.profile}`} component={DrupalProfileItemPage} />
        <Route path={`${EDrupalRoutes.genealogy}`} component={DrupalGenealogyPage} />
        <Route path={`${EDrupalRoutes.changePassword}`} component={DrupalChangePasswordPage} exact={true} />
        <Route
          path={`${EDrupalRoutes.kennelOwnershipChangeRequest}/:id`}
          component={DrupalKennelOwnershipChangeRequestPage}
        />
        <Redirect to={EDrupalRoutes.dog} />
      </Switch>
    );
  } else {
    return (
      <Switch>
        <Route path={`${EDrupalRoutes.login}`} component={DrupalLoginPage} exact={true} />
        <Route path={`${EDrupalRoutes.forgottenPassword}`} component={DrupalForgottenPasswordPage} exact={true} />
        <Route path={`${EDrupalRoutes.babyDog}`} component={DrupalBabyDogListPage} exact />
        <Route path={`${EDrupalRoutes.babyDog}/:id`} component={DrupalBabyDogDetail} />
        <Route path={`${EDrupalRoutes.affix}`} component={DrupalAffixList} />
        <Route path={`${EDrupalRoutes.competition}`} component={DrupalCompetitionListPage} exact />
        <Route path={`${EDrupalRoutes.competition}/:id`} component={DrupalCompetitionItemPage} />
        <Route path={`${EDrupalRoutes.register}`} component={DrupalRegisterPage} exact={true} />
        <Route path={`${EDrupalRoutes.affix}`} component={DrupalAffixList} />
        <Route path={`${EDrupalRoutes.emailError}/:errorType/:email?`} component={DrupalEmailErrorPage} />
        <Redirect to={`${EDrupalRoutes.login}?uri=${location?.pathname}`} />
      </Switch>
    );
  }
};
